// https://owlcarousel2.github.io/OwlCarousel2/docs/api-options.html

jQuery(document).ready(function() {
    jQuery('.owl-carousel').owlCarousel({
        loop:true,
        nav:true,
        center:false,
        dots:false,
        items:4,
        // stagePadding: 24,
        stagePadding: 5,
        // margin:40,
        margin:10,
        navText:["<span class='dashicons dashicons-arrow-left-alt2'></span>","<span class='dashicons dashicons-arrow-right-alt2'></span>"],
        responsive : {
            // breakpoint from 0 up
            0 : {
                items:1,
                stagePadding: 12,
                margin:20,
                nav:true,
            },
            // breakpoint from 600 up
            600 : {
                items:2,
                stagePadding: 18,
                margin:30,
                nav:true,
            },
            // breakpoint from 900 up
            900 : {
                items:4,
                stagePadding: 5,
                margin:10,
                nav:true,
            }
        }
    })
}); 
